module.exports = __webpack_public_path__ + "static/media/project0.e6102ce1.jpeg";